import { useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import api from '../utils/api';
import PageHeading from './PageHeading';
import { resolveBuildingNav } from '../navigation/buildingNavigation';

/**
 * Buildings-module header ?? `ancestors < title` nav + peer sections + optional tabs.
 */
export default function BuildingPageHeading({
  buildingId,
  buildingName: buildingNameProp,
  title,
  extraTrail,
  unitsSsCode,
  infoTitle,
  infoChildren,
  actions,
  tabs,
  activeTab,
  onTabChange,
}) {
  const { pathname, search } = useLocation();

  const { data: buildingFetched } = useQuery({
    queryKey: ['building', buildingId],
    queryFn: async () => (await api.get(`/buildings/${buildingId}`)).data,
    enabled: !!buildingId,
    staleTime: 60_000,
  });

  const buildingName =
    buildingNameProp ||
    buildingFetched?.name ||
    buildingFetched?.data?.name ||
    undefined;

  const hasChiller = !!(
    buildingFetched?.has_chiller ??
    buildingFetched?.data?.has_chiller
  );

  const { data: inspectionModules, isError: inspectionMenuError } = useQuery({
    queryKey: ['building', buildingId, 'inspection-menu'],
    queryFn: async () =>
      (await api.get(`/inspection-modules/buildings/${buildingId}/menu`)).data?.data || [],
    enabled: !!buildingId,
    staleTime: 15_000,
  });

  const { trail, subPages } = resolveBuildingNav({
    pathname,
    search,
    buildingId,
    buildingName,
    extraTrail,
    unitsSsCode,
    hasChiller,
    inspectionModules: inspectionMenuError ? undefined : inspectionModules,
  });

  return (
    <PageHeading
      title={title}
      trail={trail}
      subPages={subPages}
      infoTitle={infoTitle}
      infoChildren={infoChildren}
      actions={actions}
      tabs={tabs}
      activeTab={activeTab}
      onTabChange={onTabChange}
    />
  );
}
